import { QueryKey } from '@/constants/shared';
import { getWithdrawExchangeRate } from '@molecularlabs/nucleus-frontend';
import { useQuery } from '@tanstack/react-query';
import { useCurrentVault } from '../hooks/useCurrentVault';

export const useWithdrawToken = () => {
  const { vault, chainId, vaultKey } = useCurrentVault();
  const tokenSymbol = Object.values(
    vault?.withdraw.sourceChains[chainId]?.destinationChains[chainId]?.wantTokens ?? {},
  )[0]?.symbol;

  const { data: exchangeRate = 0 } = useQuery({
    queryKey: [QueryKey.GetWithdrawExchangeRate, tokenSymbol, vaultKey],
    queryFn: async () => {
      if (!chainId || !tokenSymbol) return 0;
      try {
        const exchangeRateResponse = await getWithdrawExchangeRate({
          vaultKey,
          sourceChainId: chainId,
          wantTokenSymbol: tokenSymbol,
          destinationChainId: chainId,
          minimumFractionDigits: 2,
        });
        if (typeof exchangeRateResponse === 'string') return Number(exchangeRateResponse);
        if (exchangeRateResponse === undefined) return 0;
        throw exchangeRateResponse;
      } catch (e) {
        console.error(e);
        return 0;
      }
    },
    enabled: Boolean(chainId && tokenSymbol),
  });
  return {
    tokenSymbol,
    exchangeRate,
  };
};
